module.exports = __webpack_public_path__ + "img/icon_chn.3ca0c88d.png";